import { useEffect } from "react";
import NavBarTop from "../NavBarTop";
import BannerContacto from "../components/BannerContacto";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import env from "../config";
let urlMedia = env.url;

function Concesionarios() {
  const datosConcesionarios = [
    {
      id: "Bogota",
      datos: [
        {
          nombre: "BOGOTÁ, SEDE FONTIBÓN",
          descripcion: "Servicio de Venta y Posventa o Vitrinas",
          telefono: "+573106392803",
          direccion: "Sector Fontibón CR 126A #17-50",
          url: "https://goo.gl/maps/iUnCP1YSMsv9ibpQA",
          img: urlMedia + "concesionarios/fontibon.jpg",
          alt: "",
        },
        {
          nombre: "BOGOTÁ, SEDE CALLE 80",
          descripcion: "Servicio de Venta o Vitrinas",
          telefono: "+573106392803",
          direccion: "Sector Cota sentido Siberia - Bogotá  Kilometro 2.2",
          url: "https://www.google.com/maps/place/Sinotruk+-+Sede+Calle+80/@4.7450731,-74.1417551,17z/data=!3m1!4b1!4m6!3m5!1s0x8e3f9b7383578045:0x11b5288aa3e231a3!8m2!3d4.7450731!4d-74.1417551!16s%2Fg%2F11v3_62jsc?entry=ttu",
          img: urlMedia + "concesionarios/calle80.jpg",
          alt: "",
        },
      ],
    },
    {
      id: "Duitama",
      datos: [
        {
          nombre: "DUITAMA, SEDE VEHICENTRO",
          descripcion: "Servicio de Venta y Posventa o Vitrinas",
          telefono: "+573125237893",
          direccion: "Km 4 vía Paipa-duitama, Sector san lorenzo",
          url: "https://maps.app.goo.gl/G5p77GSbM58MtKW57",
          //img: urlMedia + "concesionarios/calle80.jpg",
          alt: "",
        },
      ],
    },
    {
      id: "Cali",
      datos: [
        {
          nombre: "CALI, SEDE VEHICENTRO",
          descripcion: "Servicio de Venta y Posventa o Vitrinas",
          telefono: "+573147082286 | +573207704645",
          direccion: "CI. 15 # 36 - 93",
          url: "https://maps.app.goo.gl/VZqoppd9CynQbCuo8",
          //img: urlMedia + "concesionarios/calle80.jpg",
          alt: "",
        },
      ],
    },
    {
      id: "Medellín",
      datos: [
        {
          nombre: "MEDELLÍN, SEDE BIABLE",
          descripcion: "Servicio de Posventa",
          telefono: "+573001120043",
          direccion: "Km 3 vía Variante Caldas Cra 48 97 Sur",
          url: "",
          //img: urlMedia + "concesionarios/calle80.jpg",
          alt: "",
        },
      ],
    },
    {
      id: "PEREIRA",
      datos: [
        {
          nombre: "PEREIRA, SEDE BIABLE",
          descripcion: "Servicio de Posventa",
          telefono: "+573001120043",
          direccion: "Calle 105 # 14 A-65 BOD. 7 Bartolovento",
          url: "https://maps.app.goo.gl/PWFGzomrCxarQMAM8",
          //img: urlMedia + "concesionarios/calle80.jpg",
          alt: "",
        },
      ],
    },
    {
      id: "BARANQUILLA",
      datos: [
        {
          nombre: "BARRANQUILLA, SEDE BIABLE",
          descripcion: "Servicio de Posventa",
          telefono: "+573001120043",
          direccion:
            "Km 2,5 Vía La Cordialidad, detrás del Tres Aceros Steckerl-Galapa",
          url: "",
          //img: urlMedia + "concesionarios/calle80.jpg",
          alt: "",
        },
      ],
    },
    {
      id: "VILLAVICENCIO",
      datos: [
        {
          nombre: "VILLAVICENCIO, SEDE TULOG",
          descripcion: "Servicio de Venta y Posventa o Vitrinas",
          telefono: "+573186856642",
          direccion: "Cr 1 Cl 18 Bodega 15 Villa Nieves",
          url: "https://maps.app.goo.gl/nc7rHs4jX1PkFBPk8",
          //img: urlMedia + "concesionarios/calle80.jpg",
          alt: "",
        },
      ],
    },{
      id: "NEIVA",
      datos: [
        {
          nombre: "NEIVA, SEDE TULOG",
          descripcion: "Servicio de Venta y Posventa o Vitrinas",
          telefono: "+573164742566",
          direccion: "Carrera 5 #26 Sur 172",
          url: "https://maps.app.goo.gl/V4w8hGttpxgPCa3P6",
          //img: urlMedia + "concesionarios/calle80.jpg",
          alt: "",
        },
      ],
    },
    {
      id: "CHÍA",
      datos: [
        {
          nombre: "CHÍA, SEDE PRINCIPAL MOTOMART S.A",
          descripcion: "Servicio de Venta y Posventa o Vitrinas",
          telefono: "(601) 676 1314 | +573214986030",
          direccion: "Km 9 Carretera central Chía - Briceño",
          url: "https://maps.app.goo.gl/nZpZBgjuYLovGoBn6",
          //img: urlMedia + "concesionarios/calle80.jpg",
          alt: "",
        },
      ],
    },
    {
      id: "CARTAGENA",
      datos: [
        {
          nombre: "CARTAGENA, SEDE BIABLE",
          descripcion: "Servicio de Posventa",
          telefono: "+573001120043",
          direccion: "Centro Empresarial Ternera 1 Bodega 3",
          url: "",
          //img: urlMedia + "concesionarios/calle80.jpg",
          alt: "",
        },
      ],
    },
    {
      id: "ZIPAQUIRÁ",
      datos: [
        {
          nombre: "ZIPAQUIRÁ, SEDE ZIPATRACTORES",
          descripcion: "Servicio de Venta y Posventa o Vitrinas",
          telefono: "+573103055375",
          direccion: "Km 4 Aut. Central vía Zioaquirá - Ubaté",
          url: "https://maps.app.goo.gl/igqKEZ1HpDMGgzhh6",
          //img: urlMedia + "concesionarios/calle80.jpg",
          alt: "",
        },
      ],
    },
  ];

  useEffect(() => {
    const navButtons = document.querySelectorAll(".btnConcesionarios");
    navButtons.forEach((link, index) => {
      link.addEventListener("click", (ev) => {
        clickConcesionario(ev.target.getAttribute("option"));
      });
    });

    const clickConcesionario = (val) => {
      let container = document.querySelector(".boxConcesionarios");

      let buscarDatos = datosConcesionarios.find((dato) => dato.id === val);
      console.log(buscarDatos);
      let datosGrid = buscarDatos.datos;
      let auxTable = "";

      // datosGrid.forEach((datos) => {
      //   auxTable += "<div class='concesionariosFlex'><div class='concesionariosFlexText textConcesionario'><p class='nombreConcesionario'>" + datos.nombre + "</p><p class='descConcesionario'>" + datos.descripcion + "</p><span class='direccionConcesionario'>" + datos.direccion + "</span><p class='telefonoConcesionario'><span>Línea directa </span>" + datos.telefono + "</p><span class='linkConcesionario'><a href='" + datos.url + "' target='_blank'>UBICACIÓN</a></span></div><div class='concesionariosFlexImg imgConcesionario'><img src='" + datos.img + "' alt='" + datos.alt + "' /></div></div>"
      // })
      datosGrid.forEach((datos) => {
        auxTable +=
          "<div class='concesionariosFlex'><div class='concesionariosFlexText textConcesionario'><p class='nombreConcesionario'>" +
          datos.nombre +
          "</p><p class='descConcesionario'>" +
          datos.descripcion +
          "</p><a target='_blank' href=tel:" +
          datos.telefono +
          "class=''>" +
          datos.telefono +
          "</a><span class='direccionConcesionario'>" +
          datos.direccion +
          "</span><p class='telefonoConcesionario'></p><span class='linkConcesionario'><a href='" +
          datos.url +
          "' target='_blank'>UBICACIÓN</a></span></div><div class='concesionariosFlexImg imgConcesionario'><img src='" +
          datos.img +
          "' alt='" +
          datos.alt +
          "' /></div></div>";
      });

      container.innerHTML = auxTable;
    };
  });
  return (
    <>
      <Helmet>
        <title>Concesionarios en Colombia | Vehicentro</title>
        <meta
          name="description"
          content="Visitanos en nuestros concesionarios en Bogota: Bogotá sede Fontibón y Bogota sede calle 80"
        />
        <meta
          name="keywords"
          content="camion, camiones, venta de camiones, camiones en colombia, tracto"
        ></meta>
        <meta name="robots" content="index, follow"></meta>
      </Helmet>
      <NavBarTop />
      <p className="tituloConcesionario">
        ENCUENTRA TU CONCESIONARIO MÁS CERCANO
      </p>
      <div className="btnConcesionariosContainer">
        {datosConcesionarios.map((dato, i) => (
          <div key={i} className="btnConcesionarios">
            <a className="btn6" option={dato.id} href="#">
              {dato.id}
            </a>
          </div>
        ))}
      </div>
      <div className="boxConcesionarios">
        <span className="spanText">
          Selecciona el concesionario en la ciudad más cercana
        </span>
      </div>
      <BannerContacto />
      <Footer />
    </>
  );
}

export default Concesionarios;
